module.exports = __webpack_public_path__ + "static/media/whatsapp.c94b9ae7.svg";